// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2ihYH","selects":"Documents_selects__9UQMw"};